export function tryUntilTrue(fn: () => boolean, interval = 100) {
  const intervalId = setInterval(() => {
    if (fn()) clearTimeout(intervalId);
  }, interval);
}